import styled from 'styled-components';

export const LabelBaseStyled = styled.label`
  display: inline-block;
  margin-bottom: 0.5rem;
`;
